namespace khi.bk117.view.parts
{
	import Debugger = com.enirva.debug.Debugger;
	import EventDispatcher = com.enirva.event.EventDispatcher;

	/*
	 * Historyの時計アイコン
	 */
	export class HistoryClock extends EventDispatcher
	{
		private container:JQuery;
		
		private columns:JQuery[];

		private indicator:YearIndicator;

		private startPoint:JQuery;
		private endPoint:JQuery;

		private isShow:number;

		private chaseType:number;

		private currentColumnIndex:number;

		private yearData:number[];

		private indicatorPer:number[];

		constructor()
		{
			super();

			this.isShow = -1;
			this.chaseType = -1;
			this.currentColumnIndex = -1;

			this.container = $(".sec05");
			this.startPoint = $(".sec05 .yearStart");
			this.endPoint = $(".sec05 .yearEnd");
			this.columns = [];

			this.yearData = [
				1977,
				1982,
				1993,
				1995,
				2001,
				2016,
				2019
			];
			
			this.indicatorPer = [
				0,
				0.2,
				0.4,
				0.6,
				0.8,
				1,
				1
			];

			$(".sec05 .columnContainer .lineColumn").each((index:number, elem:Element):void=>
			{
				this.columns.push($(elem).find("h4"));
			});

			this.indicator = new YearIndicator(this.yearData[0], this.indicatorPer[0]);
		}


		public update(sc:number, h:number):void
		{
			//Debugger.text(0, (sc >> 0) + " " + (h >> 0));

			const top:number = this.container.offset().top;
			const cont_h:number = this.container.height();
			
			//Debugger.text(1, (top >> 0) + " " + (cont_h >> 0));

			if (sc > (top + cont_h))
			{
				if (this.isShow != 0)
				{
					this.isShow = 0;
					//Debugger.log("hide1");
				}
			}
			else if ((sc + h) > top)
			{
				if (this.isShow != 1)
				{
					this.isShow = 1;
					//Debugger.log("show");
				}
			}
			else
			{
				if (this.isShow != 0)
				{
					this.isShow = 0;
					//Debugger.log("hide2");
				}
			}

			if (this.isShow == 1)
			{
				this.chase(sc, h, top, cont_h);
			}
		}


		/*
		 * 追従させる
		 */
		private chase(sc:number, h:number, top:number, cont_h:number):void
		{
			const startPos:number = this.startPoint.offset().top;
			const endPos:number = this.endPoint.offset().top;

			if ((endPos - sc) < (h / 2))
			{
				if (this.chaseType != 0)
				{
					//Debugger.text(2, "下に外れた");
					this.indicator.container.removeClass("fixed");
					this.indicator.container.addClass("freeEnd");
					this.chaseType = 0;
				}
			}
			else if ((startPos - sc) < (h / 2))
			{
				if (this.chaseType != 1)
				{
					//Debugger.text(2, "侵入開始");
					this.indicator.container.addClass("fixed");
					this.indicator.container.removeClass("freeEnd");
					this.chaseType = 1;
				}
			}
			else
			{
				if (this.chaseType != 2)
				{
					//Debugger.text(2, "上に外れている");
					this.indicator.container.removeClass("fixed");
					this.indicator.container.removeClass("freeEnd");
					this.chaseType = 2;
				}
			}

			if (this.chaseType == 1)
			{
				//表示範囲内なので年代のチェック

				const indicatorOffset:number = this.indicator.container.offset().top;

				let min_dis:number = 99999;
				let nearIndex:number = -1;

				for (var i:number = 0; i < this.columns.length; i++)
				{
					const h4_top:number = this.columns[i].offset().top;
					const dis:number = Math.abs(h4_top - indicatorOffset);
					if (dis < min_dis)
					{
						min_dis = dis;
						nearIndex = i;
					}
				}

				if (nearIndex >= 0)
				{
					if (this.currentColumnIndex != nearIndex)
					{
						this.currentColumnIndex = nearIndex;
						this.indicator.yearTo(this.yearData[nearIndex], this.indicatorPer[nearIndex]);
					}
				}
			}
			
			/*
			if ((indicatorOffset - sc) < (h / 2))
			{
				Debugger.text(2, "下から中央に固定");
				//this.indicator.container.removeClass("fixed").addClass("fixed");
			}
			else
			{
				Debugger.text(2, "それ以外");
				//this.indicator.container.removeClass("fixed");
			}
			*/
		}


		/*
		 * 追従しない
		 */
		private unchase():void
		{
			this.deleteEnterFrame;
		}
	}


	/*
	 * 年代インジケータクラス
	 */
	class YearIndicator extends EventDispatcher
	{
		public container:JQuery;

		private text:JQuery;

		private circle:JQuery;

		private currYear:number;

		private currPer:number;

		private readonly MIN_YEAR:number = 1977;

		private readonly MAX_YEAR:number = 2019;

		private isMotion:boolean;

		//for enterframe

		private sa:number;

		private tmp:number;

		private cc:number;

		private percent:number;

		private year:number;


		constructor(def_year:number, def_per:number)
		{
			super();

			this.container = $(".sec05 .yearContainer");
			this.text = $(".sec05 .yearContainer .year");
			this.circle = $(".sec05 .yearContainer .timerCircle");

			this.currYear = this.MIN_YEAR;
			this.currPer = this.per(this.MIN_YEAR);
			
			this.text.text(this.currYear);

			this.yearTo(def_year, def_per);

			this.onEnterFrame = (deltaTime:number):void =>
			{
				if (this.isMotion)
				{
					this.sa += 0.015;
					this.currPer += this.tmp = (this.percent - this.currPer) * this.sa;
					const value:number = (1 - this.currPer) * 283;
					this.circle.css({"stroke-dashoffset":value});
	
					this.currYear += (this.year - this.currYear) * this.sa;
					this.text.text(this.currYear >> 0);
	
					//console.log(this.currPer + " " + this.percent);
	
					if ((++this.cc > 5) && (Math.abs(this.tmp) < 0.005))
					{
						this.isMotion = false;
						this.currPer = this.percent;
						const value:number = (1 - this.currPer) * 283;
						this.circle.css({"stroke-dashoffset":value});
						
						this.currYear = this.year;
						this.text.text(this.currYear >> 0);
					}
				}
			};
		}


		public yearTo(year:number, indicatorPer:number):void
		{
			this.percent = indicatorPer;//this.per(year);
			this.year = year;
			this.sa = 0;
			this.tmp = 0;
			this.cc = 0;

			this.isMotion = true;
			/*
			this.deleteEnterFrame;

			window.setTimeout(()=>
			{
				const per:number = this.per(year);
				let sa:number = 0;
				let tmp:number = 0;

				this.onEnterFrame = (deltaTime:number):void =>
				{
					sa += 0.015;
					this.currPer += tmp = (per - this.currPer) * sa;
					const value:number = (1 - this.currPer) * 283;
					this.circle.css({"stroke-dashoffset":value});

					this.currYear += (year - this.currYear) * sa;
					this.text.text(this.currYear >> 0);

					console.log(this.currPer + " " + per);

					if (Math.abs(tmp) < 0.005)
					{
						this.deleteEnterFrame;
						this.currPer = per;
						const value:number = (1 - this.currPer) * 283;
						this.circle.css({"stroke-dashoffset":value});
						
						this.currYear = year;
						this.text.text(this.currYear >> 0);
					}
				};
			}, 3);
			*/
		}


		private per(year:number):number
		{
			return (year - this.MIN_YEAR) / (this.MAX_YEAR - this.MIN_YEAR);
		}
	}
}

